import React from 'react';

import CustomSection from '../../custom-general/custom-section';
import ParseHTML from '../../../common/ParseHTML';

import classNames from './style.module.scss';

interface Props {
	summary: string;
}

const SPLIT_KEY = '-----';

const ExecutiveSummary: React.FC<Props> = ({ summary }) => {
	const splitText = summary.split(SPLIT_KEY);

	return (
		<>
			{splitText.map((text) => (
				<CustomSection key={text} sectionTitle="Executive Summary">
					<div className={classNames.executiveSummaryBody}>
						<ParseHTML text={text} />
					</div>
				</CustomSection>
			))}
		</>
	);
};

export default ExecutiveSummary;
